import { Plus, FileVideo } from 'lucide-react'
import { useAuthorities } from '@/hooks/useAuthorities'

export default function MediaReleaseFormsPage() {
  const authorities = useAuthorities()
  
  if (!authorities.canViewMRF()) {
    return (
      <div className="p-6">
        <div className="text-center py-12">
          <h1 className="text-2xl font-bold text-foreground">Access Denied</h1>
          <p className="text-muted-foreground mt-2">
            You don't have permission to view Media Release Forms.
          </p>
        </div>
      </div>
    )
  }
  
  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Media Release Forms</h1>
          <p className="text-muted-foreground mt-1">
            Manage media release forms and approvals
          </p>
        </div>
        {authorities.canManageMRF() && (
          <button className="btn btn-primary btn-md">
            <Plus className="mr-2 h-4 w-4" />
            Create Form
          </button>
        )}
      </div>

      {/* Content */}
      <div className="card">
        <div className="card-content">
          <div className="text-center py-12">
            <FileVideo className="mx-auto h-12 w-12 text-muted-foreground" />
            <h3 className="mt-2 text-lg font-medium text-foreground">
              Media Release Forms
            </h3>
            <p className="mt-1 text-muted-foreground">
              This section will contain media release form management and approval workflows.
            </p>
            {authorities.canManageMRF() && (
              <div className="mt-6">
                <button className="btn btn-primary btn-md">
                  <Plus className="mr-2 h-4 w-4" />
                  Create First Form
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
